import axios from 'axios'

const endpoint = `${window.env && window.env.baseHost}/api/boitata/v1/categories`

export const getMenu = () =>
  axios.get(`${endpoint}/tree`, { withCredentials: true })

export const getMenuVA = () =>
  axios.get(`${endpoint}/tree?va=true`, { withCredentials: true })

export const getChildren = (id) =>
  axios.get(`${endpoint}/${id}/children`, { withCredentials: true })
